<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <form @submit.prevent="submitPassword">
          <v-card
            class="mx-auto"
            max-width="500"
          >
            <v-card-title class="bg-primary d-flex align-center">
              <div class="banner-side d-flex align-center">
                <img
                  src="../../assets/NewLogo/BC_Whales_Logo_White_Primary.png"
                  alt="BC Whales Logo"
                >
              <!--<humpback-logo
                class="appbar-vertical-align hidden-xs"
              />-->
              </div>
              <span
                class="text-h5 white-text text-center"
                style="word-break: break-word"
              >
                Reset Password
              </span>
              <div class="banner-side" />
            </v-card-title>
            <v-divider />
            <v-card-text style="height: 210px">
              <div>
                <div v-if="!saved">
                  <v-text-field
                    v-model="password"
                    label="Password"
                    prepend-icon="mdi-lock"
                    type="password"
                    :rules="passwordValidation"
                    name="password"
                  />
                  <v-text-field
                    v-model="confirmPassword"
                    label="Confirm Password"
                    prepend-icon="mdi-check"
                    type="password"
                    :rules="confirmValidation"
                    name="comfirmPassword"
                  />
                </div>
              </div>
              <v-row
                v-if="saved"
                style="justify-content: center; font-size: medium"
                class="mt-6 ml-2"
              >
                {{ message }}
              </v-row>
              <v-row
                v-if="!saved"
                style="justify-content: center; font-size: medium"
                class="mt-1 ml-1"
              >
                {{ message }}
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row
                class="mb-4 mr-2"
                justify="end"
              >
                <v-btn
                  v-if="saved"
                  color="primary"
                  :to="loginPath"
                >
                  <span>Return to Login</span>
                </v-btn>
                <v-btn
                  v-if="!saved"
                  color="secondary"
                  :to="loginPath"
                >
                  <span>Return to Login</span>
                </v-btn>
                <v-btn
                  v-if="!saved"
                  class="ml-2"
                  color="primary"
                  type="submitPassword"
                >
                  <span>Save</span>
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import HumpbackLogo from "@/components/svgs/HumpbackLogo";


export default {
  components: {
    // HumpbackLogo,
  },

  data() {
    return {
      message: "",
      password: "",
      confirmPassword: "",
      passwordValidation: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 6) || "Password must be greater than 6 characters",
      ],
      confirmValidation: [
        (v) => !!v || "Confirm password is required",
        (v) =>
          v === this.password || "The password confirmation does not match.",
      ],
      saved: false,
      canSave: false,
      loginPath: "/login",
    };
  },
  computed: {
    ...mapGetters({
      user: "reset/user",
    }),
  },
  async created() {
    this.message = "";
  },
  methods: {
    ...mapActions({
      setUser: "reset/setUser",
      resetPassword: "reset/resetPassword",
      finish: "reset/finish",
    }),
    checkCanSave() {
      return (
        this.password === this.confirmPassword && this.password.length >= 6
      );
    },
    async submitPassword() {
      const searchQuery = window.location.search;
      const urlParam = new URLSearchParams(searchQuery);
      const token = urlParam.get("token");
      if (this.checkCanSave()) {
        try {
          await this.resetPassword({
            passToken: token,
            password: this.password,
          });
          this.confirmPassword = "";
          this.password = "";
          this.message =
            "We have successfully reset your password. To login with your new password click return to login below.";
          this.saved = true;
        } catch (e) {
          console.log(e);
          this.message =
            "Something went wrong. Try resending the reset password link, or contacting support.";
        }
      }
    },
  },
};
</script>
